/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetExternalUserCommands() {
  const response = await $.soap({
    body: {
      GetExternalUserCommands: {
        $xmlns: 'http://dla.mil/ems/bpm/user'
      }
    },
    blueprintArrays: ['GetExternalUserCommandsResponse.tuple'],
    blueprint: {
      commands: [
        '$..GetExternalUserCommandsResponse.tuple',
        {
          id: '$.old.ExternalUserCommand.CommandID',
          name: '$.old.ExternalUserCommand.CommandName',
          branch: '$.old.ExternalUserCommand.ServiceBranchName',
          branchID: '$.old.ExternalUserCommand.ServiceBranchID',
          region: '$.old.ExternalUserCommand.RegionName',
          regionID: '$.old.ExternalUserCommand.RegionID',
          approvalStatusID: '$.old.ExternalUserCommand.ApprovalStatusID'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.commands;
}
